import { teamLanderIndex } from 'constants/page-names';
import { PREMIUM, productToPath } from 'containers/product-initializer/products';
import { analyticLinks, createTeamHomeLink, statisticsLinks } from 'pages/game-center/game-center-links';

export const getBasePath = () => productToPath[PREMIUM].path;

export const specialTeams = basePath => [
    { menu: 'Powerplay', path: `${basePath}${analyticLinks.powerPlayer.to}` },
    { menu: 'Penalty Kill', path: `${basePath}${analyticLinks.penaltyKill.to}` }
];

export const shooting = basePath => [
    { menu: 'Shooting', path: `${basePath}${statisticsLinks.shooting.to}` },
    { menu: 'Goaltending', path: `${basePath}${statisticsLinks.goaltenders.to}` }
];

export const possession = basePath => [
    { menu: 'Possession', path: `${basePath}${statisticsLinks.possession.to}` },
    { menu: 'Passing', path: `${basePath}${statisticsLinks.passing.to}` },
    { menu: 'Entries', path: `${basePath}${statisticsLinks.entries.to}` },
    { menu: 'Exits', path: `${basePath}${statisticsLinks.exits.to}` }
];

export const secondNavBar = (basePath, teamId) => [
    {
        menu: 'Main',
        path: teamId ? `${basePath}/${teamLanderIndex}/${teamId}` : createTeamHomeLink(basePath).to
    },
    { menu: 'Summary', path: `${basePath}${analyticLinks.summary.to}` },
    { menu: 'Skater', path: `${basePath}${analyticLinks.skaters.to}` },
    {
        menu: 'Special Teams',
        path: `${basePath}${analyticLinks.powerPlayer.to}`,
        subPath: specialTeams(basePath)
    },
    { menu: 'Configurator', path: `${basePath}${analyticLinks.configurator.to}` },
    { menu: 'Shooting', path: `${basePath}${statisticsLinks.shooting.to}`, subPath: shooting(basePath) },
    {
        menu: 'Possession',
        path: `${basePath}${statisticsLinks.possession.to}`,
        subPath: possession(basePath)
    },
    { menu: 'Shifts', path: `${basePath}${statisticsLinks.shifts.to}` }
];
